const REGEX_METACHARACTERS = /[\\.^$*+?()[\]{}|]/g;
const POSTGREST_QUOTED_ESCAPES = /[\\"]/g;

/**
 * PostgREST `or` filter matching rows where any column contains `term` literally,
 * ignoring case. Returns null for an empty term; whitespace is kept as typed.
 *
 * Uses `imatch` (PostgreSQL `~*`) because PostgREST treats `*` as `%` in like/ilike
 * patterns, so ilike cannot match a literal asterisk. Regex metacharacters are escaped so
 * the pattern is literal, then the value is double-quoted for PostgREST's reserved
 * characters (, . : ( )) with `\` and `"` escaped inside the quotes. The client
 * URL-encodes the result; never escape for SQL or URLs here.
 */
export function containsAnyFilter(columns: readonly string[], term: string): string | null {
  if (term === '') {
    return null;
  }
  const literal = term.replace(REGEX_METACHARACTERS, (char) => `\\${char}`);
  const quoted = `"${literal.replace(POSTGREST_QUOTED_ESCAPES, (char) => `\\${char}`)}"`;
  return columns.map((column) => `${column}.imatch.${quoted}`).join(',');
}
